export default __webpack_public_path__ + "ff0e3d433f08d8a351477fbb059e2af2.mp3";